var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var parse = require('date-fns/fp/parse').default
var format = require('date-fns/fp/format').default
var isValid = require('date-fns/fp/isValid').default

require('aem-libs-angularjs/src/components/responsive-date-picker/responsive-date-picker.component.js')

angular.module('inputDateCmp', ['ResponsiveDatePickerCmp'])
  .component('inputDate', {
    template: require('./input-date.component.tpl.html'),
    controller: InputDateCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      hideDate: '<',
      value: '=',
      minDate: '<',
      isWeekendDisabled: '<',
      disabledDates: '<'
    }
  })

InputDateCtrl.$inject = ['i18n']

function InputDateCtrl (i18n) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)

    vm.currentDate = new Date()
    vm.day = new Date()
    vm.changedDay = changedDay
    if (angular.isUndefined(vm.value[vm.formField.id])) {
      if (vm.hideDate) {
        vm.day = null
      } else {
        parseDay()
      }
    } else {
      vm.day = parse(new Date())('dd.MM.yyyy')(vm.value[vm.formField.id])
    }
  }

  function parseDay () {
    var dayIsValid = isValid(vm.day)
    if (dayIsValid) {
      vm.value[vm.formField.id] = format('dd.MM.yyyy')(vm.day)
    } else {
      vm.value[vm.formField.id] = null
    }
  }

  function changedDay () {
    var dayIsValid = isValid(vm.day)
    if (dayIsValid) {
      vm.value[vm.formField.id] = format('dd.MM.yyyy')(vm.day)
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('required', true)
    } else {
      vm.value[vm.formField.id] = null
    }
  }
}
